import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { AlertService } from './alert.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { LoaderService } from '@app-shared/services/loader.service';

dayjs.extend(utc);
dayjs.extend(timezone);

export const ApiRequestInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const notificationService = inject(NotificationService);
    const alertService = inject(AlertService);
    const loaderService = inject(LoaderService);

    if (!req.url.includes('http')) {
        req = req.clone({
            headers: req.headers.set('Time-Zone', dayjs.tz.guess()),
            url: environment.apiUrl + req.url
        });
    }
    req = req.clone({ withCredentials: true });

    return next(req).pipe(
        tap((event) => {
            if (event instanceof HttpResponse) {
                if (event.headers.has('crm-app-version') && event.headers.get('crm-app-version') !== environment.version) {
                    notificationService.notificationBannerUpdated.emit({ show: true });
                }
            }
        }),
        catchError((error: any) => {
            if (error instanceof HttpErrorResponse) {
                if (error.status === 401 && !error.url!.includes('/api/auth/login')) {
                    authService.logout();
                } else if ((error.status >= 400 && error.status < 500) || error.status === 503) {
                    if (typeof error.error === 'object') {
                        alertService.showWarningAlert(error.error.message);
                    } else {
                        alertService.showWarningAlert(error.error);
                    }
                } else if (error.status === 500) {
                    if (typeof error.error === 'object') {
                        alertService.showErrorAlert(error.error.message);
                    } else {
                        alertService.showErrorAlert(error.error);
                    }
                } else if (error.status === 502) {
                    alertService.showErrorAlert('Bad Gateway');
                } else {
                    alertService.showErrorAlert('Server Error');
                }
            }
            loaderService.hideSpinner();
            return throwError(() => error);
        })
    );
};
